export const position = [
  {
    x: -82.1416,
    y: 673.3017,
    w: 415.3237,
    d: 0,
  },
  {
    x: 603.5876,
    y: 610.579,
    w: 402,
    d: 24,
  },
  {
    x: 912.5318,
    y: 759.4427,
    w: 217.5379,
    d: 0,
  },
  {
    x: 1210.181,
    y: 733.0493,
    w: 221.5315,
    d: 25,
  },
  {
    x: 1514.8148,
    y: 701.2533,
    w: 383.1626,
    d: 354,
  },
  {
    x: 5.3564,
    y: 506.0077,
    w: 160.6516,
    d: 39,
  },
  {
    x: 229.8073,
    y: 521.0681,
    w: 350.4405,
    d: 338,
  },
  {
    x: 1087.8679,
    y: 669.0375,
    w: 133.3538,
    d: 333,
  },
  {
    x: 1388.818,
    y: 577.7401,
    w: 176.5316,
    d: 340,
  },
  {
    x: 1733.9832,
    y: 504.2744,
    w: 324.7343,
    d: 15,
  },
  {
    x: -20.354,
    y: 337.3691,
    w: 160.8285,
    d: 311,
  },
  {
    x: 607.9094,
    y: 489.906,
    w: 190.0025,
    d: 44,
  },
  {
    x: 1150.8214,
    y: 473.1702,
    w: 262.3862,
    d: 26,
  },
  {
    x: 1565.4816,
    y: 463.5228,
    w: 176.0248,
    d: 19,
  },
  {
    x: 247.7215,
    y: 335.9618,
    w: 160.248,
    d: 17,
  },
  {
    x: 895.5348,
    y: 430.0415,
    w: 190.7588,
    d: 340,
  },
  {
    x: 1298.2964,
    y: 252.6336,
    w: 324.545,
    d: 350,
  },
  {
    x: 1718.4085,
    y: 227.4045,
    w: 324.5737,
    d: 40,
  },
];
